<ngb-carousel
  class="carousel-class"
  *ngIf="noticiasCargadas || hayNoticias"
  [interval]="intervalo"
  (slide)="onSlide($event)"
  [pauseOnHover]="true"
  [showNavigationIndicators]="true"
>

  <ng-template ngbSlide *ngFor="let item of noticias; let i = index" [id]="'slide-' + i">

    <img
      class="d-block w-100"
      [src]="files + item.nombreImagen"
      [alt]="item.titulo"
      loading="lazy"
      decoding="async"
    >

  </ng-template>

</ngb-carousel>